import type { RouteObject } from 'react-router-dom'

import type { NavItem } from '@/app/registry'

import { WorkoutPage } from './WorkoutPage'

// Тренировка в зале: активная тренировка, офлайн. История и ввод задним числом — /workouts.
export const routes: RouteObject[] = [{ path: '/workout', element: <WorkoutPage /> }]

export const nav: NavItem[] = [{ path: '/workout', label: 'Тренировка', icon: 'workout', mobile: 'tab', order: 20 }]
